import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState = {
	state: false,
	options: {
		children: null
	}
};
const dialogSlice = createSlice({
	name: 'dialog',
	initialState: initialState,
	reducers: {
		openDialog: (state: any, action: PayloadAction<any>) => {
			state.state = true;
			state.options = action.payload;
		},
		closeDialog: (state: any) => ({
			...initialState
		})
	}
});

export const { openDialog, closeDialog } = dialogSlice.actions;

export default dialogSlice.reducer;
